
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-495ed724!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProductSettingsPage.ProductRow.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductSettingsPage.ProductRow.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-495ed724!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductSettingsPage.ProductRow.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/productsettings/ProductSettingsPage.ProductRow.vue
// module id = 696
// module chunks = 2